// Shared scorecard selection for the classic dashboard's two
// scorecard-scoped charts (Criteria Trends + Scorecard Performance).
// Selection precedence: the scope-tab picker (new dashboard) wins;
// otherwise the classic Select's redux-stored choice; otherwise the
// first scorecard. The Select node renders only when no tab picker
// owns the choice, and both charts share the stored selection so they
// stay in lockstep.
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import Select from '@/components/forms/Select'
import { setData } from '@/reducers/qa-copilot/qa-copilot.redux'

import { usePickedEntity } from '../helpers/cohort'

export const useClassicScorecardSelection = (selectTestId) => {
  const dispatch = useDispatch()
  const picked = usePickedEntity('scorecard')
  const allScorecards = useSelector((reduxState) => reduxState.qaCopilot.data.scorecards || [])
  const classicSid = useSelector(
    (reduxState) => reduxState.qaCopilot.data.classicScorecardSid || null
  )

  const selectedScorecard = useMemo(() => {
    if (picked?.value) {
      return picked.value
    }
    if (classicSid && allScorecards.some((scorecard) => scorecard.value === classicSid)) {
      return classicSid
    }
    return allScorecards[0]?.value || null
  }, [picked, classicSid, allScorecards])

  const selectedScorecardOption = useMemo(
    () => allScorecards.find((scorecard) => scorecard.value === selectedScorecard) || null,
    [allScorecards, selectedScorecard]
  )

  const scorecardSelect = !picked?.value && !isEmpty(allScorecards) && (
    <div className="scorecard-perf-scorecard-select" data-testid={selectTestId}>
      <Select
        options={allScorecards}
        value={selectedScorecard}
        onChange={(event) => {
          dispatch(setData({ classicScorecardSid: event.value }))
        }}
        placeholder="Select Scorecard"
        isClearable={false}
      />
    </div>
  )

  return { picked, allScorecards, selectedScorecard, selectedScorecardOption, scorecardSelect }
}
